<template>
  <div class="entity-select-field d-inline-flex flex-row align-baseline">
    <v-autocomplete
        outlined
        :dense="dense"
        :placeholder="placeholder"
        :label="label"
        :items="items"
        v-model="selectedItem"
        :loading="loading"
        :search-input.sync="searchTerm"
        hide-details="auto"
        :rules="rules"
        clearable
        :hide-no-data="true"
        :return-object="true"
        item-text="text"
        item-value="value.id"
        :filter="() => true"
        :append-icon="null"/>

    <part-select-dialog ref="partSelectDialog"
                        @selected="setSelected"/>

    <v-btn v-if="showSelectDialogButton"
           icon
           @click="openSelectDialog"
           :title="$t('entitySelect.selectFromList')">
      <v-icon>mdi-form-select</v-icon>
    </v-btn>

    <PartCreationDialog
        v-if="renderComponent && showAddDialogButton && $featurePermissions.partCRUD"
        @selected="setSelected"
        @dialogClosed="forceRerender"/>
  </div>
</template>

<script>
import PartsService from '@/services/PartsService';
import PartSelectDialog from '@/views/parts/PartSelectDialog';
import PartCreationDialog from '@/views/parts/PartCreationDialog';

export default {
  name: 'PartSelectField',
  components: { PartSelectDialog, PartCreationDialog },
  props: {
    value: {
      required: true,
    },
    placeholder: {
      type: String,
    },
    label: {
      type: String,
    },
    showAddDialogButton: {
      type: Boolean,
      default: false,
    },
    showSelectDialogButton: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },

    rules: Array,
  },
  data: () => ({
    selectedItem: null,
    loading: false,
    searchTerm: null,
    timerId: null,
    entities: [],
    renderComponent: true,
  }),
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        if (this.valueComparator(this.value, val)) {
          return;
        }
        this.$emit('input', val);
        this.$emit('change', val);
      },
    },
    items() {
      const entitiesForSelection = this.entities.slice();

      if (
          this.selected &&
          !entitiesForSelection.some((entity) => entity.id === this.selected.id)
      ) {
        entitiesForSelection.push(this.selected);
      }
      return entitiesForSelection.map(this.mapToItem);
    },
  },
  methods: {
    mapToItem(part) {
      return {
        text: this.$options.filters.part(part),
        value: part,
      };
    },

    valueComparator(one, two) {
      if (one == null && two == null) {
        return true;
      }
      if (one == null || two == null) {
        return false;
      }
      return one.id === two.id;
    },

    search() {
      if (!this.searchTerm) {
        this.entities = [];
        this.selectedItem = null;
        return;
      }
      if (this.selectedItem && this.searchTerm === this.selectedItem.text) {
        return;
      }

      this.loading = true;
      PartsService.findPartsByNameOrIdentification(this.searchTerm)
          .then((result) => {
            this.entities = result.data;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => (this.loading = false));
    },

    openSelectDialog() {
      this.$refs.partSelectDialog.show();
    },

    setSelected(part) {
      this.selected = part;
      this.$nextTick(() => this.setSelectionToAutoComplete(part));
    },
    setSelectionToAutoComplete(selected) {
      if (selected != null) {
        const item = this.mapToItem(selected);
        this.selectedItem = item;
        this.searchTerm = item.text;
      } else {
        this.selectedItem = null;
        this.searchTerm = null;
      }
    },
    forceRerender() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
  },
  watch: {
    selectedItem(item) {
      if (item) {
        this.selected = item.value;
      } else {
        this.selected = null;
      }
    },
    selected(part) {
      this.setSelectionToAutoComplete(part);
    },

    searchTerm() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      this.timerId = setTimeout(() => {
        this.search();
      }, 500);
    },
  },
  mounted() {
    if (this.selected) {
      this.setSelectionToAutoComplete(this.selected);
    }
  },
};
</script>

<style></style>
